<app-spinner-service></app-spinner-service>

<div class="p-grid">
  <div class="p-col-12">
    <app-toolbar-search (onSearch)="applyFilterGlobal($event)" placeholder="Pesquise por dados da planilha...">
      <div leftContent>
        <button pButton label="Voltar" icon="pi pi-arrow-left" (click)="cancelar()" class="p-button-secondary"></button>
        <button pButton label="Importar Planilha" icon="pi pi-upload" (click)="importarPlanilha()" class="p-button-success"></button>
      </div>
    </app-toolbar-search>

    <div *ngIf="errorMessage" class="error-message">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ errorMessage }}</span>
    </div>

    <div *ngIf="!errorMessage">
      <div class="file-info-section">
        <div class="file-info-card">
          <div class="file-icon">
            <i class="pi pi-file-excel"></i>
          </div>
          <div class="file-details">
            <h3 class="file-name">{{ nomeArquivo }}</h3>
            <div class="file-meta">
              <span class="file-size">{{ formatarTamanhoArquivo(tamanhoArquivo) }}</span>
              <span class="file-separator">•</span>
              <span class="file-records">{{ dadosPlanilha.length }} registros</span>
            </div>
          </div>
        </div>
      </div>

      <div class="table-container">
        <p-table #dt [value]="dadosPlanilha" [paginator]="true" [rows]="10" 
          [globalFilterFields]="['data', 'descricao', 'valor', 'tipo']"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
          class="custom-table" [loading]="loading" [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[5, 10, 20, 50]">

          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="data" style="width: 15%">Data <p-sortIcon field="data"></p-sortIcon></th>
              <th pSortableColumn="descricao" style="width: 50%">Descrição <p-sortIcon field="descricao"></p-sortIcon></th>
              <th pSortableColumn="valor" style="width: 20%">Valor <p-sortIcon field="valor"></p-sortIcon></th>
              <th pSortableColumn="tipo" style="width: 15%">Tipo <p-sortIcon field="tipo"></p-sortIcon></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-dado>
            <tr>
              <td>{{ dado.data }}</td>
              <td class="description-cell">{{ dado.descricao }}</td>
              <td class="value-cell">{{ dado.valor | currency:'BRL' }}</td>
              <td class="type-cell">
                <span class="chip chip-nfse">NFS-e</span>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4" class="empty-message">
                <div class="empty-content">
                  <i class="pi pi-file-excel" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
                  <h3>Nenhum dado encontrado</h3>
                  <p>Não há dados para exibir na planilha.</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
